import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSearchParam } from 'react-use'

import { TtButton } from '@23/react'

import './WebinarFoyerOptionsComponent.scss'

/**
 * WebinarHostOptions
 */
export const WebinarHostOptions = ({ onOptionClick }) => {
  const isDemoMode = useSearchParam('demo') !== null

  return (
    <div className="webinars-foyer-options-container">
      <TtButton
        size="small"
        color="info"
        onClick={() => {
          onOptionClick('producer')()
        }}
      >
        <FormattedMessage defaultMessage="Host the webinar" />
      </TtButton>
      <TtButton
        size="small"
        color="info"
        variant="outline"
        onClick={onOptionClick('presenter')}
      >
        <FormattedMessage defaultMessage="Join as a speaker" />
      </TtButton>
      {isDemoMode && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <button
          className="webinars-foyer-demo-mode-trigger"
          type="button"
          onClick={() => {
            onOptionClick('producer')()
          }}
        >
          <FormattedMessage defaultMessage="Run in DemoMode" />
        </button>
      )}
    </div>
  )
}

WebinarHostOptions.propTypes = {
  onOptionClick: PropTypes.func.isRequired,
}

/**
 * WebinarSpeakerOptions
 */
export const WebinarSpeakerOptions = ({ onOptionClick }) => (
  <div className="webinars-foyer-options-container">
    <TtButton size="small" color="info" onClick={onOptionClick('presenter')}>
      <FormattedMessage defaultMessage="Join as a speaker" />
    </TtButton>
  </div>
)

WebinarSpeakerOptions.propTypes = {
  onOptionClick: PropTypes.func.isRequired,
}
